import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/educomdetacom.webp';
import screenshot_target from '../../../images/letterfunnel/jeroenmerry.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jeroen Merry"
      firstname="Jeroen"
      companyname="Educom & Detacom"
      competition="Calco en Createment"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeroenmerry.js